export const AJAX_URL = getAjaxUrl()

function getAjaxUrl() {
  return window.WpAjaxUrl
    ? window.WpAjaxUrl.ajaxurl
    : '/wp/wp-admin/admin-ajax.php'
}
